import type { FaireProductEntity } from "../../entity_types/product";

export const p_pnmgacsnph: FaireProductEntity = {
  token: "p_pnmgacsnph",
  type: "product",
  name: "Reusable Nursing Pads | Breastfeeding, Postpartum, New Mom",
  brandToken: "b_2524b7cv4g",
  brandName: "Le Lolo",
  imageUrl:
    "https://cdn.faire.com/fastly/6f53720a09cf4990577bfb89dc2119ec32aab2cf1f8c2d22414baaf01698699b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/78732c76bb811ccd4df7ccce74d32ebfd04d08b3f652b309119ee284996a5009.jpeg",
    "https://cdn.faire.com/fastly/9174400e6b702d8b5840058939df7b68f0fe3a5597344788dad7d08e4033e2d6.jpeg",
    "https://cdn.faire.com/fastly/f013052bccbc0b0d20a3f84058aa1af4e44c742c70d95806c864bc9d61605caa.jpeg",
    "https://cdn.faire.com/fastly/9b8c66bde3d72cd8320d429f270314259e2856858af432f4ebf3ad7ec1367c98.jpeg",
    "https://cdn.faire.com/fastly/b28650db9de67a0c0730d61471689658f269fc0d1b96b3a4bf9c036443b11395.jpeg",
    "https://cdn.faire.com/fastly/84cb3e29e45b1cde5caced91cee8762d3913c8d0e751cfac87eedd508185b676.jpeg",
    "https://cdn.faire.com/fastly/3a98c44e805697494cf98939530a0cb09a551ac2cbd69c14dce9e6f321d5c4fb.jpeg",
    "https://cdn.faire.com/fastly/b271d73f8d6a54424160c51aabd1a0940014c4cfebba66108c762cdb6cb014f7.jpeg",
  ],
  priceDollars: 10,
  description:
    " * Made with 3 layers of organic bamboo \n * Holds 2x more liquid than competitors \n * Hypoallergenic, antibacterial, and eco-friendly \n * Includes a machine-washable bag \n\n\nMade with 3 layers of organic bamboo, our reusable nursing pads hold 2x more liquid than our competitor, locking in leaks without irritation.\n\nThey are hypoallergenic, antibacterial, and eco-friendly, and provide a contoured, invisible fit under clothing while offering lasting comfort.\n\nPaired with a luxe machine-washable bag, our reusable nursing pads are designed for durability—because better protection should be comfortable.\n\n*To make it easier for your customers, we include a beautifully designed product display card in every order. This way, they can see exactly what’s inside the box without opening it. We’ve attached images so you can get a feel for the look and style.*",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:52:43.687Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
